export const dateStringIsInFuture = date => {
    const dateInput = new Date(date).setHours(0,0,0,0);
    const currentDate = new Date().setHours(0,0,0,0);

    return dateInput > currentDate;
}